import React from "react";
import { VOCAB_CONSTANTS } from "../../constants/vocabConstants";

const ChapterNavigation = ({ currentPage, onPageChange, length, loading }) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        অধ্যায় নির্বাচন করুন
      </h3>
      <div className="flex flex-wrap gap-3">
        {Array.from({ length: length }, (_, i) => (
          <button
            key={i}
            onClick={() => onPageChange(i)}
            disabled={loading}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${
              currentPage === i
                ? "bg-indigo-600 text-white shadow-lg transform scale-105"
                : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:border-gray-400 disabled:opacity-50"
            }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChapterNavigation;
